"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { chakra, useMultiStyleConfig, forwardRef } from "@chakra-ui/react";
import { XMarkStyles, XMarkVariants } from "./XMark.types";
const XMark = forwardRef((_a, ref) => {
    var { variant = XMarkVariants.DEEP_BLUE, style = XMarkStyles.FILLED } = _a, rest = __rest(_a, ["variant", "style"]);
    const styles = useMultiStyleConfig("XMark", { variant });
    if (variant === XMarkVariants.ULTRA_GREEN && style === XMarkStyles.FILLED) {
        throw new Error('Ultra Green variant does not support "filled" style');
    }
    return (_jsx(chakra.svg, Object.assign({ ref: ref, width: "100%", height: "auto", viewBox: "0 0 158 158", fill: "none", xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMin", sx: styles.container }, rest, { children: style === XMarkStyles.FILLED ? (_jsx(chakra.path, { d: "M79 27.9313L51.0687 0H0V51.0687L27.9313 79L0 106.931V158H51.0687L79 130.069L106.931 158H158V106.931L130.069 79L158 51.0687V0H106.931L79 27.9313Z", sx: styles.symbol })) : (_jsx(chakra.path, { d: "M156.104 1.896V50.2834L128.728 77.6593L127.387 79L128.728 80.3407L156.104 107.717V156.104H107.717L80.3407 128.728L79 127.387L77.6593 128.728L50.2834 156.104H1.896V107.717L29.2719 80.3407L30.6126 79L29.2719 77.6593L1.896 50.2834V1.896H50.2834L77.6593 29.2719L79 30.6126L80.3407 29.2719L107.717 1.896H156.104ZM158 0H106.931L79 27.9313L51.0687 0H0V51.0687L27.9313 79L0 106.931V158H51.0687L79 130.069L106.931 158H158V106.931L130.069 79L158 51.0687V0Z", sx: styles.symbol })) })));
});
XMark.displayName = "XMark";
export default XMark;
//# sourceMappingURL=XMark.js.map